/** Matricule déjà porté par une autre fiche du même tenant. */
export function matriculeDejaPris(
  salaries: ReadonlyArray<{ id: string; matricule: string }>,
  matricule: string,
  exceptId?: string,
): boolean {
  const cible = matricule.trim().toLowerCase();
  if (!cible) return false;
  return salaries.some((s) => s.id !== exceptId && s.matricule.trim().toLowerCase() === cible);
}

/** Numéro de facture déjà utilisé. */
export function numeroFactureDejaPris(
  factures: ReadonlyArray<{ id: string; numero: string }>,
  numero: string,
  exceptId?: string,
): boolean {
  const cible = numero.trim().toLowerCase();
  if (!cible) return false;
  return factures.some((f) => f.id !== exceptId && f.numero.trim().toLowerCase() === cible);
}
